module.exports = __webpack_public_path__ + "img/4cb66efb137ce809f66335a1363399e1.svg";